import React, {useState, useEffect, useContext} from "react";
import PrivateRoute from './js/context/PrivateRoute';
import {AuthContext} from "./js/context/auth";
import {JWT} from "./js/constants/local-storage";
import {library} from '@fortawesome/fontawesome-svg-core';
import {store} from './js/context/store';
import {useHistory} from 'react-router-dom';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {functions} from "./js/constants/common-functions";
import background from "./images/omniscanbackgroundoffice.jpg";
import ForgeModal from "./js/components/forge/ForgeModal";
import OmniScanEntry from './js/pages/home/OmniScanEntry';

import {
	faChartBar,
	faCity,
	faCogs,
	faArrowLeft,
	faArrowRight,
	faArrowCircleUp,
	faArrowCircleDown,
	faEquals,
	faPlusCircle,
	faBook,
	faInfoCircle,
	faMinusCircle,
	faFileExport,
	faChess,
	faChartLine,
	faMapMarkerAlt,
	faAngleDown,
	faAngleUp,
	faUser,
	faSearch,
	faFilter,
	faHome,
	faAdjust,
	faListUl,
	faCheck,
	faCalendarAlt,
	faGlobeEurope,
	faTrafficLight,
	faTimes,
	faAngleRight,
	faPlane,
	faRestroom,
	faSatelliteDish,
	faRss,
	faWheelchair,
	faBaby,
	faSubway,
	faArrowUp,
	faArrowDown,
	faPaperclip,
	faAngleDoubleRight,
	faCamera,
	faDonate,
	faRoute,
	faLaptop,
	faLaptopHouse,
	faExclamationTriangle,
	faCouch,
	faUsers,
	faEdit,
	faArrowCircleLeft,
	faArrowCircleRight,
	faPlus,
	faPlusSquare,
	faTrashAlt,
	faLayerGroup,
	faBookReader,
	faGlobe,
	faSmile,
	faAngry,
	faCoffee,
	faDumbbell,
	faCar,
	faDeaf,
	faCaretSquareUp,
	faPray,
	faUtensils,
	faPause,
	faPlay,
	faChartPie,
	faThLarge,
	faChevronCircleDown,
	faBusAlt,
	faInfo,
	faExpand,
	faBell,
	faPlayCircle,
	faImages,
	faFileAlt,
	faQuestion,
	faHandshake,
	faAngleLeft,
	faAngleDoubleLeft,
	faExpandArrowsAlt,
	faTruck,
	faMap,
	faMinus,
	faFile,
	faPen,
	faEnvelope,
	faBinoculars,
	faMale,
	faFemale,
	faChild,
	faDownload,
	faRuler,
	faSignOutAlt,
	faThermometerHalf,
	faVolumeUp,
	faCloud,
	faHeart,
	faTrain,
	faCounch,
	faBus,
	faLightbulb,
	faProjectDiagram,
	faCheckSquare,
	faBolt,
	faSync,
	faTools,
	faDesktop,
	faFilm,
	faEye,
	faChartArea,
	faLock,
	faComments,
	faComment,
	faTable
} from '@fortawesome/free-solid-svg-icons'

import{
	BrowserRouter as Router,
	Switch,
	Route
} from "react-router-dom";

import SystemLogin from './js/pages/SystemLogin';
import LogOut from './js/pages/LogOut';
import Home from './js/pages/home/Home';
import MobileHome from './js/pages/home/mobile/MobileHome';
import HomeBlue from './js/pages/home/HomeBlue';
import HomeUtilisation from './js/pages/home/HomeUtilisation';
import Map from './js/pages/Map';
import AssetInformation from './js/pages/AssetInformation';
import Facility from './js/pages/facility/Facility';
import Site from './js/pages/Site';
import DashboardLease from './js/pages/dashboardlease/DashboardLease';
import Utilisation from './js/pages/utilisation/Utilisation';
import UtilisationAll from './js/pages/utilisation/UtilisationAll';
import UtilisationAllMeeting from './js/pages/utilisation/UtilisationAllMeeting';
import UtilisationAllNonStandard from './js/pages/utilisation/UtilisationAllNonStandard';
import UtilisationBreakdownBySpaceType from './js/pages/utilisation/UtilisationBreakdownBySpaceType';
import UtilisationTimeline from './js/pages/utilisation/UtilisationTimeline';
import UtilisationActivity from './js/pages/utilisation/UtilisationActivity';
import UtilisationProfiles from './js/pages/utilisation/UtilisationProfiles';
import UtilisationWorkstations from './js/pages/utilisation/UtilisationWorkstations';
import UtilisationOutliers from './js/pages/utilisation/UtilisationOutliers';
import UtilisationOccupancyInUse from './js/pages/utilisation/UtilisationOccupancyInUse';
import UtilisationHoursOccupiedUtilisationCapacity from './js/pages/utilisation/UtilisationHoursOccupiedUtilisationCapacity';
import UtilisationUnusedDesks from './js/pages/utilisation/UtilisationUnusedDesks';
import UtilisationSummaryOrganisation from './js/pages/utilisation/UtilisationSummaryOrganisation';
import UtilisationFloorPlan from './js/pages/utilisation/UtilisationFloorPlan';
import UtilisationSensors from './js/pages/utilisation/UtilisationSensors';
import WorksettingPerformance from './js/pages/utilisation/WorksettingPerformance';
import UsageInspector from './js/pages/utilisation/inspector/UsageInspector';
import RoomBookings from './js/pages/utilisation/RoomBookings';

import FloorplanUtilisationPage from './js/pages/floorplan/FloorplanUtilisationPage';

import Timetable from './js/pages/Timetable';
import TimetableDashboard from './js/pages/TimetableDashboard';

import SpaceAll from './js/pages/space/SpaceAll';
import SpaceOrgDashboard from './js/pages/spaceorgs/SpaceOrgDashboard';
import SpaceOrgBuilding from './js/pages/spaceorgs/SpaceOrgBuilding';
import Outliers from './js/pages/outliers/Outliers';
import SpaceWorksettings from './js/pages/space/SpaceWorksettings';
import FacilityFloors from './js/pages/space/FacilityFloors';
import UtilisationRoom from './js/pages/utilisation/UtilisationRoom';
import UploadFile from './js/pages/UploadFile';
import UploadFloorPlanPdf from './js/pages/UploadFloorPlanPdf';
import Insights from './js/pages/insights/Insights';
import Insight from './js/pages/insights/Insight';
import InsightDashboard from './js/pages/insights/InsightDashboard';
import InsightsDocumentGenerator from './js/pages/insights/InsightsDocumentGenerator';
import SnippetSearch from './js/pages/snippetsearch/SnippetSearch';
import SnippetDocumentBuilder from './js/pages/snippetdocumentbuilder/SnippetDocumentBuilder';

import DwgInteraction from './js/pages/demo/dwginteraction/DwgInteraction';

import AssetConditionMatrix from './js/pages/assets/AssetConditionMatrix';

import AdministrationHome from './js/pages/administration/AdministrationHome';
import AdministrationHomeConfiguration from './js/pages/administration/AdministrationHomeConfiguration';
import AdministrationProperties from './js/pages/administration/AdministrationProperties';
import AdministrationGeographies from './js/pages/administration/AdministrationGeographies';
import AdministrationFloorZones from './js/pages/administration/AdministrationFloorZones';
import AdministrationOrganisations from './js/pages/administration/AdministrationOrganisations';
import AdministrationClassifications from './js/pages/administration/AdministrationClassifications';
import AdministrationSpaceTypes from './js/pages/administration/AdministrationSpaceTypes';
import AdministrationResources from './js/pages/administration/AdministrationResources';
import AdministrationUsers from './js/pages/administration/AdministrationUsers';
import AdministrationHomeResources from './js/pages/administration/AdministrationHomeResources';
import AdministrationPropertiesEdit from './js/pages/administration/AdministrationPropertiesEdit';
import AdministrationGeographiesEdit from './js/pages/administration/AdministrationGeographiesEdit';
import AdministrationFloorZonesEdit from './js/pages/administration/AdministrationFloorZonesEdit';
import AdministrationOrganisationsEdit from './js/pages/administration/AdministrationOrganisationsEdit';
import AdministrationClassificationsEdit from './js/pages/administration/AdministrationClassificationsEdit';
import AdministrationSpaceTypesEdit from './js/pages/administration/AdministrationSpaceTypesEdit';
import AdministrationResourcesEdit from './js/pages/administration/AdministrationResourcesEdit';
import AdministrationUsersEdit from './js/pages/administration/AdministrationUsersEdit';
import AdministrationHomeResourcesEdit from './js/pages/administration/AdministrationHomeResourcesEdit';
import AdministrationSvg from './js/pages/administration/AdministrationSvg';
import AdministrationUploadBuildingPhotos from './js/pages/administration/AdministrationUploadBuildingPhotos';
import AdministrationClient from './js/pages/administration/AdministrationClient';
import AdministrationClientCommercial from './js/pages/administration/AdministrationClientCommercial';
import AdministrationPhotoTourZips from './js/pages/administration/AdministrationPhotoTourZips';
import AdministrationDocumentTypes from './js/pages/administration/AdministrationDocumentTypes';
import AdministrationDocumentTypeEdit from './js/pages/administration/AdministrationDocumentTypeEdit';
import AdministrationResourceDirectories from './js/pages/administration/AdministrationResourceDirectories';
import AdministrationResourceDirectoryEdit from './js/pages/administration/AdministrationResourceDirectoryEdit';
import AdministrationResourceRevisions from './js/pages/administration/AdministrationResourceRevisions';
import AdministrationResourceRevisionEdit from './js/pages/administration/AdministrationResourceRevisionEdit';
import AdminImportScreen from './js/pages/administration/AdminImportScreen';
import AdministrationPublisher from './js/pages/administration/AdministrationPublisher';
import AdministrationBulkUpdater from './js/pages/administration/AdministrationBulkUpdater';

import Documents from './js/pages/documents/Documents';

import GiraffeAdmin from './js/pages/administration/giraffe/GiraffeAdmin';

import Eva from './js/pages/eva/Eva';
import EvaDirectory from './js/pages/eva/EvaDirectory';
import EvaMainChat from './js/pages/eva/ai/EvaMainChat';
import EvaWorkplace from './js/pages/eva/EvaWorkplace';

import ProjectsHome from './js/pages/projects/home/ProjectsHome';
import ProjectEdit from './js/pages/projects/edit/ProjectEdit';
import ProjectGantt from './js/pages/projects/gantt/ProjectGantt';

import MovesEdit from './js/pages/projects/moves/edit/MovesEdit';

import WorkflowList from './js/pages/workflow/list/WorkflowList';
import WorkflowTask from './js/pages/workflow/list/WorkflowTask';

import QuestionnaireQuestionAnalytics from './js/pages/workflow/analytics/QuestionnaireQuestionAnalytics';
import QuestionnaireQuestionResponses from './js/pages/workflow/configuration/QuestionnaireQuestionResponses';
import QuestionnaireConfiguration from './js/pages/workflow/configuration/QuestionnaireConfiguration';
import QuestionnaireQuestionnaireEdit from './js/pages/workflow/configuration/QuestionnaireQuestionnaireEdit';


import ImageAssetDemo from './js/pages/ai/ImageAssetDemo';

import RoomBooking from './js/pages/roombooking/RoomBooking';
import BuildingNavigator from './js/pages/roombooking/BuildingNavigator';

import SharePoint from './js/pages/documentlibrary/SharePoint';

import Resources from './js/pages/Resources';
import Matterport from './js/pages/scanningvendors/Matterport';
import Giraffe from './js/pages/scanningvendors/Giraffe';

import UtilisationGridImportPanel from './js/pages/hiddenutilities/UtilisationGridImportPanel';


import TestPdf from './js/pages/TestPdf';


import CmsEntry from './js/pages/cms/admin/CmsEntry';

import './App.css';

library.add(
	faChartBar,
	faCity,
	faCogs,
	faArrowLeft,
	faArrowRight,
	faArrowCircleUp,
	faArrowCircleDown,
	faEquals,
	faPlusCircle,
	faBook,
	faInfoCircle,
	faMinusCircle,
	faFileExport,
	faChess,
	faChartLine,
	faMapMarkerAlt,
	faAngleDown,
	faAngleUp,
	faUser,
	faSearch,
	faFilter,
	faHome,
	faAdjust,
	faListUl,
	faCheck,
	faCalendarAlt,
	faGlobeEurope,
	faTrafficLight,
	faTimes,
	faAngleRight,
	faPlane,
	faRestroom,
	faSatelliteDish,
	faRss,
	faWheelchair,
	faBaby,
	faSubway,
	faArrowUp,
	faArrowDown,
	faPaperclip,
	faAngleDoubleRight,
	faCamera,
	faDonate,
	faRoute,
	faLaptop,
	faLaptopHouse,
	faExclamationTriangle,
	faCouch,
	faUsers,
	faEdit,
	faArrowCircleLeft,
	faArrowCircleRight,
	faPlus,
	faPlusSquare,
	faTrashAlt,
	faLayerGroup,
	faBookReader,
	faGlobe,
	faSmile,
	faAngry,
	faCoffee,
	faDumbbell,
	faCar,
	faDeaf,
	faCaretSquareUp,
	faPray,
	faUtensils,
	faPause,
	faPlay,
	faChartPie,
	faThLarge,
	faChevronCircleDown,
	faBusAlt,
	faInfo,
	faExpand,
	faBell,
	faPlayCircle,
	faImages,
	faFileAlt,
	faQuestion,
	faHandshake,
	faAngleLeft,
	faAngleDoubleLeft,
	faExpandArrowsAlt,
	faTruck,
	faMap,
	faMinus,
	faFile,
	faPen,
	faEnvelope,
	faBinoculars,
	faMale,
	faFemale,
	faChild,
	faDownload,
	faRuler,
	faSignOutAlt,
	faThermometerHalf,
	faVolumeUp,
	faCloud,
	faHeart,
	faTrain,
	faCouch,
	faBus,
	faLightbulb,
	faProjectDiagram,
	faCheckSquare,
	faBolt,
	faSync,
	faTools,
	faDesktop,
	faFilm,
	faEye,
	faChartArea,
	faLock,
	faComments,
	faComment,
	faTable
);




export default function App(){
	const [showEntry, setShowEntry] = useState(
	    () => sessionStorage.getItem("omniscanEntrySeen") !== "true"
	);
		const existingTokens = localStorage.getItem(JWT) || "null";
		const globalState = useContext(store);
		const {dispatch} = globalState;
		const [authTokens, setAuthTokens] = useState(existingTokens);
		const [displayThis, setDisplayThis] = useState('none');
		const [displayWarning, setDisplayWarning] = useState("none");
		const [isLoaded, setIsLoaded] = useState(false);
		const history = useHistory();
		const [coverBackground, setCoverBackground] = useState("");
		const [headerButtonClick, setHeaderButtonClick] = useState("0");
		const [hideHeader, setHideHeader] = useState(false);
		const [thisBackground, setThisBackground] = useState("");
		  
		  
		const [forgeOpen, setForgeOpen] = useState(false);
		const [forgeUrn, setForgeUrn] = useState(null);
		const [forgeTitle, setForgeTitle] = useState("");
		const [forgeMode, setForgeMode] = useState("OMNISCAN");
		
		
		const openForge = ({ urn, title, mode = "OMNISCAN" }) => {
		  setForgeUrn(urn);
		  setForgeTitle(title);
		  setForgeMode(mode);
		  setForgeOpen(true);
		};

		const closeForge = () => {
		  setForgeOpen(false);
		  setForgeUrn(null);
		  setForgeTitle("");
		};
		
		function FacilityWithForge(props) {
		  return (
		    <Facility
		      {...props}
		      onOpenForge={openForge}
		    />
		  );
		}
		
		 window.onclick = function(event){
        console.log("TARGET");
        console.log(event.target);
     };
		
		const notExpired = (token) => {
			var exp = JSON.parse(atob(token.split('.')[1]))["exp"];
			var tokenExpire = 1000*exp;
			return Date.now() < tokenExpire;
		};
		
		const getLoggedIn = () => {
			if(globalState && globalState.state && globalState.state.loggedIn){
				return globalState.state.loggedIn;
			}
			else{
				return "";
			}
		};
		
		const getTheme = () => {
			if(globalState && globalState.state && globalState.state.theme){
				return globalState.state.theme;
			}
			else{
				return "";
			}
		};
		
		
		useEffect((authtokens) => {
			
			if(authTokens && authTokens !== 'null' && notExpired(authTokens)){
				
				functions.getArrayFromAjax("/resolutionsoftwareplatform/getclient", null, setBackgroundCoverImage);
				
				setDisplayThis('flex');
				if(!isLoaded){
					setIsLoaded(true);	
					
				}
				
			}
			else{
				localStorage.setItem(JWT, "null");
				setDisplayThis('none');
				setAuthTokens(null);
			}
			
		}, [store, headerButtonClick, getLoggedIn()]);

		// Effect to hide header
		useEffect(() => {

			if (window.location.pathname === '/') {

				setHideHeader(true)

			} else {

				setHideHeader(false)

			}
 
		}, [window.location, getLoggedIn()])
		
		const goLogOut = () => {
		history.push('/logout');
	};
	
	const setBackgroundCoverImage = (client) => {
		try{		
				//let backgroundSource = client.resourceFolderUrl + "/" + IMAGE_COVER;
				//functions.getFileSource(backgroundSource,
				//	setThisBackground, null);
			
			
		}
		catch(e){}	
	}
	

		const setTokens = (data) => {
			localStorage.setItem(JWT, data);
			setAuthTokens(data);
		};
	
		const appContent = {
			display:"flex",
			width:"calc(100% - 0px)",
			marginLeft:"0px",
			flexWrap:"wrap",
			flexGrow:"1",
			height:"calc(100vh - 70px)",
			background: "transparent"
		};
		
		const pageHolder = {
			display:"flex",
			marginTop:"0px",
			marginLeft:"0px",
			width:"100%",
			height:"100%",
			flexGrow:"1"
		};
		
		const fixedBackground = {
			display:"flex",
			position:"fixed",
			left:"0px",
			top:'0px',
			width:"100%",
			height:"100%",
			background:"url(" + background + ")",
			backgroundRepeat: 'no-repeat',
			backgroundPosition: 'top center',
			backgroundSize: 'cover',
			zIndex: "-1"
		};
		
		const fixedBackgroundCover = {
			display:"flex",
			position:"fixed",
			left:"0px",
			top:'0px',
			width:"100vw",
			height:"100vh",
			backgroundColor:coverBackground,
			backgroundSize:"100% 100%",
			backgroundPosition:"center",
			zIndex: "-1"
		};
		
  return (
   <div>
   
   	 <AuthContext.Provider value={{authTokens, setAuthTokens: setTokens}}>
	 
	  	 <Router style={{width:'100%', height:'100%'}}>
	  		 	<div style={fixedBackground}/>
	  		 	
	  		 	
	  			<div style={appContent}>
	  				
						<div style={{...pageHolder}}>
								
								<Switch>
						      	<Route exact path="/" component={SystemLogin}/>
						      	<PrivateRoute path="/logout" component={LogOut}/>
						      	
								<PrivateRoute
								    path="/home"
								    render={(props) =>
								        showEntry ? (
								            <OmniScanEntry
								                onEnter={() =>
								                {
								                    sessionStorage.setItem(
								                        "omniscanEntrySeen",
								                        "true"
								                    );

								                    setShowEntry(false);
								                }}
								            />
								        ) : (
								            <Home {...props} />
								        )
								    }
								/>
								
								
								<PrivateRoute path="/mobilehome" component={MobileHome}/>
								<PrivateRoute path="/matterport" component={Matterport}/>
								<PrivateRoute path="/giraffe" component={Giraffe}/>
								<PrivateRoute path="/homeblue" component={HomeBlue}/>
						      	<PrivateRoute path="/homeutilisation" component={HomeUtilisation}/>
						      	<PrivateRoute path="/map/:siteId" component={Map}/>
						      	<PrivateRoute path="/assetinformation/:assetId" component={AssetInformation}/>
								<PrivateRoute path="/testpdf" component={TestPdf}/>
								<PrivateRoute
								  path="/facility/:id"
								  render={(props) => (
								    <Facility
								      {...props}
								      onOpenForge={openForge}
								    />
								  )}
								/>
						      	<PrivateRoute path="/site/:siteId" component={Site}/>
						      	<PrivateRoute path="/dashboardlease" component={DashboardLease}/>
						      	<PrivateRoute path="/utilisation" component={Utilisation}/>
						      	<PrivateRoute path="/utilisationall/:facilityId/:spaceTypeId" component={UtilisationAll}/>
						      	<PrivateRoute path="/utilisationallmeeting/:facilityId/:spaceTypeId" component={UtilisationAllMeeting}/>
						      	<PrivateRoute path="/utilisationallnonstandard/:facilityId" component={UtilisationAllNonStandard}/>
						      	<PrivateRoute path="/utilisationbreakdownbyspacetype/:facilityId" component={UtilisationBreakdownBySpaceType}/>
						      	<PrivateRoute path="/utilisationtimeline/:facilityId" component={UtilisationTimeline}/>
						      	<PrivateRoute path="/utilisationactivity/:facilityId" component={UtilisationActivity}/>
						      	<PrivateRoute path="/utilisationprofiles/:facilityId" component={UtilisationProfiles}/>
						      	<PrivateRoute path="/utilisationworkstations/:facilityId" component={UtilisationWorkstations}/>
						      	<PrivateRoute path="/utilisationoutliers/:facilityId" component={UtilisationOutliers}/>
						      	<PrivateRoute path="/utilisationoccupancyinuse/:facilityId" component={UtilisationOccupancyInUse}/>
						      	<PrivateRoute path="/utilisationhoursoccupiedutilisationcapacity/:facilityId" component={UtilisationHoursOccupiedUtilisationCapacity}/>
						      	<PrivateRoute path="/utilisationunuseddesks/:facilityId" component={UtilisationUnusedDesks}/>
						      	<PrivateRoute path="/utilisationsummaryorganisation/:facilityId" component={UtilisationSummaryOrganisation}/>
						      	<PrivateRoute path="/spaceall/:facilityId" component={SpaceAll}/>
						      	<PrivateRoute path="/spaceworksettings" component={SpaceWorksettings}/>
						      	<PrivateRoute path="/facilityfloors/:facilityId" component={FacilityFloors}/>
						      	<PrivateRoute path="/utilisationroom" component={UtilisationRoom}/>
						      	<PrivateRoute path="/utilisationfloorplan" component={UtilisationFloorPlan}/>
						      	<PrivateRoute path="/utilisationsensors" component={UtilisationSensors}/>
								<PrivateRoute path="/roombookings" component={RoomBookings}/>
								<PrivateRoute path="/spaceorgdashboard" component={SpaceOrgDashboard}/>
								<PrivateRoute path="/spaceorgbuilding/:facilityId" component={SpaceOrgBuilding}/>
								
								<PrivateRoute path="/documents/:id" component={Documents}/>
								
								<PrivateRoute path="/worksettingperformance" component={WorksettingPerformance}/>
								<PrivateRoute path="/usageinspector" component={UsageInspector}/>
								
								<PrivateRoute path="/assets/conditionmatrix" component={AssetConditionMatrix}/>
								
								<PrivateRoute path="/outliers" component={Outliers}/>
								
								<PrivateRoute path="/insights" component={Insights}/>
								<PrivateRoute path="/insightdashboard" component={InsightDashboard}/>
								<PrivateRoute path="/insight/:id" component={Insight}/>
								<PrivateRoute path="/insightsdocumentgenerator" component={InsightsDocumentGenerator}/>
								<PrivateRoute path="/snippetsearch" component={SnippetSearch}/>
								<PrivateRoute path="/snippetdocumentbuilder" component={SnippetDocumentBuilder}/>
								
						      	<PrivateRoute path="/floorplan/utilisation/:floorId" component={FloorplanUtilisationPage}/>
						      	
						      	<PrivateRoute path="/timetable" component={Timetable}/>
						      	<PrivateRoute path="/timetabledashboard" component={TimetableDashboard}/>
						      	
						      	<PrivateRoute path="/uploadfile" component={UploadFile}/>
						      	<PrivateRoute path="/uploadfloorplanpdf" component={UploadFloorPlanPdf}/>
						      	
						      	<PrivateRoute path="/administrationhome" component={AdministrationHome}/>
								<PrivateRoute path="/administrationhomeconfiguration" component={AdministrationHomeConfiguration}/>
								<PrivateRoute path="/administrationpublisher" component={AdministrationPublisher}/>
								<PrivateRoute path="/administrationbulkupdater" component={AdministrationBulkUpdater}/>
								<PrivateRoute path="/adminimportscreen" component={AdminImportScreen}/>
						      	<PrivateRoute path="/administrationproperties" component={AdministrationProperties}/>
						      	<PrivateRoute path="/administrationgeographies" component={AdministrationGeographies}/>
								<PrivateRoute path="/administrationfloorzones" component={AdministrationFloorZones}/>
								<PrivateRoute path="/administrationorganisations" component={AdministrationOrganisations}/>
						      	<PrivateRoute path="/administrationclassifications" component={AdministrationClassifications}/>
						      	<PrivateRoute path="/administrationspacetypes" component={AdministrationSpaceTypes}/>
						      	<PrivateRoute path="/administrationresources" component={AdministrationResources}/>
						      	<PrivateRoute path="/administrationusers" component={AdministrationUsers}/>
						      	<PrivateRoute path="/administrationhomeresources" component={AdministrationHomeResources}/>
						      	<PrivateRoute path="/administrationpropertiesedit/:id" component={AdministrationPropertiesEdit}/>
								<PrivateRoute path="/administrationfloorzonesedit/:id" component={AdministrationFloorZonesEdit}/>
								<PrivateRoute path="/administrationorganisationsedit/:id" component={AdministrationOrganisationsEdit}/>
						      	<PrivateRoute path="/administrationgeographiesedit/:id" component={AdministrationGeographiesEdit}/>
						      	<PrivateRoute path="/administrationclassificationsedit/:id" component={AdministrationClassificationsEdit}/>
						      	<PrivateRoute path="/administrationspacetypesedit/:id" component={AdministrationSpaceTypesEdit}/>
						      	<PrivateRoute path="/administrationresourcesedit/:id" component={AdministrationResourcesEdit}/>
						      	<PrivateRoute path="/administrationusersedit/:id" component={AdministrationUsersEdit}/>
						      	<PrivateRoute path="/administrationhomeresourcesedit/:id" component={AdministrationHomeResourcesEdit}/>
						      	<PrivateRoute path="/administrationsvg" component={AdministrationSvg}/>
						      	<PrivateRoute path="/administrationuploadbuildingphotos" component={AdministrationUploadBuildingPhotos}/>
						      	<PrivateRoute path="/administrationclient" component={AdministrationClient}/>
						      	<PrivateRoute path="/administrationclientcommercial" component={AdministrationClientCommercial}/>
						      	<PrivateRoute path="/administrationphototourzips" component={AdministrationPhotoTourZips}/>
								<PrivateRoute path="/admin/documenttypes/list" component={AdministrationDocumentTypes}/>
								<PrivateRoute path="/administration/edit/documenttype/:id" component={AdministrationDocumentTypeEdit}/>
								<PrivateRoute path="/admin/resourcedirectories/list" component={AdministrationResourceDirectories}/>
								<PrivateRoute path="/administration/edit/resourcedirectory/:id" component={AdministrationResourceDirectoryEdit}/>
								<PrivateRoute path="/admin/resourcerevisions/list" component={AdministrationResourceRevisions}/>
								<PrivateRoute path="/administration/edit/resourcerevision/:id" component={AdministrationResourceRevisionEdit}/>
								
								<PrivateRoute path="/administration/giraffe" component={GiraffeAdmin}/>
								
								<PrivateRoute path="/eva" component={Eva}/>
								<PrivateRoute path="/evadirectory/:directoryId" component={EvaDirectory}/>
								<PrivateRoute path="/evamainchat" component={EvaMainChat}/>
								<PrivateRoute path="/evaworkplace" component={EvaWorkplace}/>
								
								<PrivateRoute path="/dwginteraction" component={DwgInteraction}/>
								
								
								<PrivateRoute path="/cms/admin/cmsentry" component={CmsEntry}/>
								
								
								<PrivateRoute path="/projects/home" component={ProjectsHome}/>
								<PrivateRoute path="/projects/edit" component={ProjectEdit}/>
								<PrivateRoute path="/projects/moves/edit" component={MovesEdit}/>
								<PrivateRoute path="/projects/gantt" component={ProjectGantt}/>
								
								<PrivateRoute path="/workflow/list" component={WorkflowList}/>
								<PrivateRoute path="/workflow/task/:questionnaireResponseId" component={WorkflowTask}/>
								<PrivateRoute path="/workflow/analytics" component={QuestionnaireQuestionAnalytics}/>
								<PrivateRoute path="/workflow/configuration/configuration" component={QuestionnaireConfiguration}/>
								<PrivateRoute path="/workflow/configuration/responses" component={QuestionnaireQuestionResponses}/>
								<PrivateRoute path="/workflow/configuration/edit" component={QuestionnaireQuestionnaireEdit}/>
								
								<PrivateRoute path="/ai/imageasset" component={ImageAssetDemo}/>
								
								<PrivateRoute path="/roombooking/floor" component={RoomBooking}/>
								
								<PrivateRoute
								  path="/resources/:id"
								  render={(props) => (
								    <Resources
								      {...props}
								      onOpenForge={openForge}
								    />
								  )}
								/>
								<PrivateRoute path="/hiddenutilities/utilisationgridimportpanel" component={UtilisationGridImportPanel}/>
								
								<PrivateRoute
								  path="/roombooking/navigator"
								  render={(props) => (
								    <BuildingNavigator
								      {...props}
								      onOpenForge={openForge}
								    />
								  )}
								/>
								
								<PrivateRoute path="/documentlibrary/sharepoint" component={SharePoint}/>
								
								</Switch>
								
						</div>
					</div>
				
		  		</Router>
				{forgeOpen && (
						    <ForgeModal
						      open={forgeOpen}
						      urn={forgeUrn}
						      title={forgeTitle}
						      onClose={closeForge}
							  viewerMode={forgeMode}
						    />
						  )}
				
		  	</AuthContext.Provider>
  	</div>
  );
	
}